import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { SEO } from '../../constants/seo';
import type { IMetadata } from '../../interfaces/metadata';

export type IState = {
  data: IMetadata | Record<string, any>;
};

const initialState: IState = {
  data: SEO,
};

const metadataSlice = createSlice({
  name: 'metadata',
  initialState,
  reducers: {
    setMetadata: (state, { payload }: PayloadAction<IMetadata>) => {
      state.data = payload;
    },
  },
});

const { actions, reducer } = metadataSlice;

export const { setMetadata } = actions;

export default reducer;
